import { inject, InjectionToken, ValueProvider } from '@angular/core';
import { AttachmentSource } from './model/attachment-source.model';

const ATTACHMENT_SOURCES = new InjectionToken<AttachmentSource[]>('The items the chat prompt bar\'s "+" menu can offer.');

/**
 * Registers one item of the prompt bar's "+" menu. Call it once per item; the registration order is the menu order.
 * The agent's `REQUEST_RESOURCES.allowed` decides which registered items show on a given turn.
 */
export function provideAttachmentSource(source: AttachmentSource): ValueProvider {
    return { provide: ATTACHMENT_SOURCES, useValue: source, multi: true };
}

/** Every registered "+" menu item, in registration order; empty when the host registered none. */
export function injectAttachmentSources(): AttachmentSource[] {
    return inject(ATTACHMENT_SOURCES, { optional: true }) ?? [];
}
